var React = require('react');

function NextTool (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"3","cy":"3","r":"3","fill":"#ADB3BC"}));
}

NextTool.defaultProps = {"width":"6","height":"6","viewBox":"0 0 6 6","fill":"none"};

module.exports = NextTool;

NextTool.default = NextTool;
